<script lang="ts">
	interface Props {
		transparent?: boolean
		class?: string
		joinTop?: boolean
		children?: import('svelte').Snippet
	}

	let { transparent = false, class: className = '', joinTop = false, children }: Props = $props()
</script>

<div
	class="
    grid grid-cols-1
    {joinTop ? 'relative rounded-b-xl' : 'rounded-xl'}
    {transparent
		? 'border border-gray-200 dark:border-gray-700'
		: 'shadow-box-shadow bg-white dark:bg-gray-800 dark:shadow-black/75'}
    {className}
  "
>
	{@render children?.()}
</div>
